<template>
  <div class="space-y-2 md:col-span-5">
    <div class="flex items-center justify-between">
      <h4>
        {{ t(mode === 'pickup' ? 'transferStart' : 'transferDestination') }}
      </h4>
      <CVButton
        v-if="isMutable && !editStation"
        variant="ghost"
        size="iconSm"
        @click.prevent="editStation = true"
      >
        <PencilIcon class="h-4 w-4" />
      </CVButton>
    </div>

    <TransferAddress v-if="!editStation || !isMutable" :transfer="transfer" :mode="mode" />
    <TransferStationEditForm
      v-else
      :transfer="transfer"
      :mode="mode"
      @saved="editStation = false"
      @cancelled="editStation = false"
    />
  </div>
</template>

<script lang="ts" setup>
import TransferAddress from '@/components/booking-forms/TransferAddress.vue';
import CVButton from '@/components/buttons/CVButton.vue';
import type { Allocation } from '@/entities/allocations/allocation.entity';
import { PencilIcon } from 'lucide-vue-next';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TransferStationEditForm from './TransferStationEditForm.vue';

const { t } = useI18n();

withDefaults(
  defineProps<{
    transfer: Allocation;
    mode: 'pickup' | 'dropoff';
    isMutable?: boolean;
  }>(),
  {
    isMutable: true,
  },
);

const editStation = ref(false);
</script>

<i18n lang="json">
{
  "en": {
    "transferStart": "Transfer Start",
    "transferDestination": "Transfer Destination"
  },
  "de": {
    "transferStart": "Transferstartort",
    "transferDestination": "Transferziel"
  },
  "es": {
    "transferStart": "Inicio del traslado",
    "transferDestination": "Destino del traslado"
  }
}
</i18n>
